import { FeedFilters } from "../types/feed";
import { FacetToken } from "../types/facets";

export function mergeToken(tokens: FacetToken[], next: FacetToken): FacetToken[] {
  // One value per key for now; replace existing
  const filtered = tokens.filter((t) => t.key !== next.key);
  return [...filtered, next];
}

export function tokensToFilters(tokens: FacetToken[]): FeedFilters {
  const filters: FeedFilters = {};
  for (const token of tokens) {
    if (token.key === "pilot") filters.pilot = token.value;
    if (token.key === "pilot_uid") filters.pilot_uid = token.value;
    if (token.key === "actor") filters.actor_uid = token.value;
    if (token.key === "unit") filters.unit_type = token.value;
    if (token.key === "weapon") filters.weapon = token.value;
    if (token.key === "airdrome") filters.airdrome = token.value;
    if (token.key === "server") filters.server_name = token.value;
    if (token.key === "event") filters.event_type = token.value;
    if (token.key === "kind") filters.kind = token.value as FeedFilters["kind"];
  }
  return filters;
}

export function filtersToTokens(filters: FeedFilters): FacetToken[] {
  const tokens: FacetToken[] = [];
  if (filters.pilot_uid) tokens.push({ key: "pilot_uid", value: filters.pilot_uid });
  if (filters.pilot) tokens.push({ key: "pilot", value: filters.pilot });
  if (filters.actor_uid) tokens.push({ key: "actor", value: filters.actor_uid });
  if (filters.unit_type) tokens.push({ key: "unit", value: filters.unit_type });
  if (filters.weapon) tokens.push({ key: "weapon", value: filters.weapon });
  if (filters.airdrome) tokens.push({ key: "airdrome", value: filters.airdrome });
  if (filters.server_name) tokens.push({ key: "server", value: filters.server_name });
  if (filters.event_type) tokens.push({ key: "event", value: filters.event_type });
  if (filters.kind) tokens.push({ key: "kind", value: filters.kind });
  return tokens;
}

